import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Order } from '@app/core/business/order/order';
import { OrderService } from '@app/core/business/order/order.service';
import { ContextService } from '@app/core/service/context.service';
import { ModalFactoryService } from '@app/core/ui/modal/modal-factory.service';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { Catalog } from '@app/core/business/catalog/catalog';
import { CatalogService } from '@app/core/business/catalog/catalog.service';
import { DialogOrderCreationComponent } from '@app/ui/dialog/dialog-order-creation/dialog-order-creation.component';
import { Company } from '@app/core/business/company/company';
import { MatDialog } from '@angular/material/dialog';
import { CompanyService } from '@app/core/business/company/company.service';
import { SortingService } from '@app/core/service/sorting.service';

@Component({
  selector: 'app-order-summary-container',
  templateUrl: './order-summary-container.component.html',
  styleUrls: ['./order-summary-container.component.scss'],
})
export class OrderSummaryContainerComponent implements OnInit, OnDestroy {

  public mobileSubscription$: Subscription;
  public isMobile: boolean;
  public catalog: Catalog;
  currentCompany: Company;
  availableCompanies: Company[] = [];

  public isSunday: boolean;
  public isMondayDelivery: boolean;
  public isAfterCutoff: boolean;
  public order: Order;
  cutoffTime: Date;


  constructor(public contextService: ContextService,
    private companyService: CompanyService,
    private modalFactory: ModalFactoryService,
    private orderService: OrderService,
    private router: Router,
    private translateService: TranslateService,
    private toastrService: ToastrService,
    private catalogService: CatalogService,
    private dialog: MatDialog,
    private sortingService: SortingService,) {
    // Redirect to dashboard if no order or company is chosen
    if (!this.contextService.context.orderCode || !this.contextService.context.companyCode) {
      this.router.navigateByUrl('/dashboard');
      return;
    }
  }

  ngOnInit(): void {

    this.contextService.fullContext$.subscribe(context => {
      this.currentCompany = context.company
    })

    const userCode = localStorage.getItem('userCode');

    this.companyService.getCompanies(userCode).subscribe(companies => {
      if (companies) {
        this.availableCompanies = companies;
      }
    });
    // Check if display is mobiel for mobile datatable
    this.checkIsMobile();
    const context = this.contextService.context;
    // Load cross selling datas only if parameters are safely defined
    if (context.companyCode && context.customerCode && context.orderCode) {
      this.catalogService
        .getCatalogs(context.companyCode, context.customerCode, context.orderCode)
        .subscribe(catalogs => {
          let filteredCatalogs = catalogs;
          if (this.contextService.fullContext.customer && !this.contextService.fullContext.customer.dateCourte) {
            filteredCatalogs = catalogs.filter(catalog => {
              return catalog.id != 'anti-gaspi-products';
            });
          }
          if (filteredCatalogs && filteredCatalogs.length > 0) {
            this.catalog = filteredCatalogs[0];
          }
        });
    }

    this.order = this.contextService.fullContext.order;
    if (this.order != null) {
      const user = this.contextService.fullContext.customer;
      // Vérifie si c'est dimanche aujourd'hui
      const now = new Date();
      this.isSunday = now.getDay() === 0; // 0 = dimanche

      // Vérifie si la livraison est prévue lundi
      const deliveryDate = new Date(this.order.deliveryDate);
      this.isMondayDelivery = deliveryDate.getDay() === 1; // 1 = lundi

      // Vérifie si l'heure actuelle est > [à user.CutoffAA - 30minute]
      this.cutoffTime = new Date(user.cutoffAA);
      this.cutoffTime.setMinutes(this.cutoffTime.getMinutes() - 30);
      this.isAfterCutoff = now > this.cutoffTime;



      if (this.isSunday && this.isMondayDelivery) {
        this.order.validityEndDate = this.cutoffTime.toISOString();
        //la variable this.contextOrder.validityEndDate dans le contextService doit etre mise à jour avec la date de fin de validité du panier
        this.contextService.fullContext.order.validityEndDate = this.order.validityEndDate;
      }
    }
  }

  ngOnDestroy(): void {
    this.mobileSubscription$.unsubscribe();
  }

  public order$ = this.contextService.fullContext$.pipe(
    map(ctx => ctx.order)
  );

  public cancelOrder(): void {
    this.modalFactory.confirm(
      () => {
        this.orderService
          .deleteCancel(
            this.contextService.context.companyCode,
            this.contextService.context.customerCode,
            this.contextService.context.orderCode
          )
          .subscribe(
            success => {
              this.contextService.resetSelectedOrder();
              this.toastrService.success(
                this.translateService.instant('order.cancelOrderSuccess')
              );
              this.router.navigateByUrl('/dashboard');
            },
            error => { }
          );
      },
      () => { },
      this.translateService.instant('modal.cancelOrderTitle')
    );
  }

  public validateOrder(): void {
    this.order = this.contextService.fullContext.order;

    /* if (true) {
      this.toastrService.error(
        this.translateService.instant('order.validationForbiddenAfter21h')
      );
      return;
    } */

    if (this.isSunday && this.isMondayDelivery && this.isAfterCutoff && this.contextService.fullContext.company.code != 'VITAFRAIS') {
      this.toastrService.error(
        this.translateService.instant('order.validationForbiddenAfterCutoffAA', { cutOffAA: new Date(this.contextService.fullContext.customer.cutoffAA).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) })
      );
      return;
    }

    // Règle existante : alerte si livraison gratuite pas atteinte
    if (this.order.price.freeDeliveryRemaining && this.order.price.freeDeliveryRemaining != "") {
      this.modalFactory.confirm(
        () => {
          this.startValidationProcess();
        },
        () => { },
        "",
        this.startValidationProcess()
      );
    } else {
      this.startValidationProcess();
    }
  }

  private openDialogComapnySwitch() {
    const dialogRef = this.dialog.open(DialogOrderCreationComponent,
      {
        data: { otherCompany: this.currentCompany.code == "PRONATURAFRANCE" ? "VITAFRAIS" : "PRONATURA" },
        width: '600px',
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // change to the other company's context
        this.contextService.setSelectedCompany(this.contextService.isVitafrais() ? 'PRONATURAFRANCE' : 'VITAFRAIS');
        this.sortingService.clearSort();
      } else {
        // redirect to dashboard
        this.router.navigateByUrl('/dashboard');
      }
    });
  }

  public startValidationProcess(): void {
    this.modalFactory.validateOrder((order: Order) => {
      this.orderService
        .postValidate(
          this.contextService.context.companyCode,
          this.contextService.context.customerCode,
          this.contextService.context.orderCode,
          order.deliveryAddress.code,
          order.deliveryDate,
          order.customCode,
          order.headerComment
        )
        .subscribe(
          success => {
            this.orderService
              .getOrder(
                this.contextService.context.companyCode,
                this.contextService.context.customerCode,
                this.contextService.context.orderCode
              )
              .subscribe(o => {
                const settings = this.contextService.fullContext.company
                  .settings;

                // If status doesn't permit modification of order
                if (
                  !settings.canAddProductStatuses.includes(o.status) &&
                  !settings.canRemoveProductStatuses.includes(o.status)
                ) {
                  // Remove the order from the context AND redirect to dashboard
                  this.contextService.resetSelectedOrder();
                  this.openDialogComapnySwitch();
                  // this.router.navigateByUrl('/dashboard');
                } else {
                  // Else, update order in context
                  this.contextService.setSelectedFullOrder(o);
                  this.openDialogComapnySwitch();
                }

                this.toastrService.success(
                  this.translateService.instant('order.validateOrderSuccess')
                );
              });
          },
          error => { }
        );
    }, this.contextService.fullContext.order);
  }

  public continueOrder(): void {
    this.router.navigateByUrl('/offers');
  }

  public reactivateOrder(): void {
    this.modalFactory.confirm(
      () => {
        this.orderService
          .postReactivate(
            this.contextService.context.companyCode,
            this.contextService.context.customerCode,
            this.contextService.context.orderCode
          )
          .subscribe(
            success => {
              this.contextService.setSelectedOrder(
                this.contextService.context.orderCode
              );
              this.toastrService.success(
                this.translateService.instant('order.reactivateOrderSuccess')
              );
            },
            error => { }
          );
      },
      () => { },
      this.translateService.instant('modal.reactivateOrderTitle')
    );
  }

  private checkIsMobile(): void {
    const checkMobile = () =>
      (this.isMobile = document.body.offsetWidth < environment.sizeLG);

    // Observe screen width to display ngx-datatable or the mobile list
    this.mobileSubscription$ = fromEvent(window, 'resize')
      .pipe(
        debounceTime(250),
        startWith(checkMobile) // Execute for first render without event triggering
      )
      .subscribe(checkMobile);
  }
}
